
import "../../../Foundation/stylable/spacing.st.css.js";
import "../../../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_Footnote";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_Footnote__root","innerContent":"wds_1_220_2_Footnote__innerContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-fill-surface-neutral":"--wds-color-fill-surface-neutral","wds-color-fill-surface-modal":"--wds-color-fill-surface-modal","wds-custom-modal-footnote-padding-vertical":"--wds-custom-modal-footnote-padding-vertical","wds-custom-modal-footnote-padding-horizontal":"--wds-custom-modal-footnote-padding-horizontal"}; 




